import React, { FC } from 'react';

import { BudgetsArticlesTable } from 'modules/budget/components/Articles/table';

export const BudgetArticles: FC<Record<string, unknown>> = () => (
  <BudgetsArticlesTable />);
